import React, { useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Admin from './components/Admin';
import AdminLogin from './components/AdminLogin';
import Vote from './components/Vote';
import Results from './components/Results';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Check localStorage on initial load
    return localStorage.getItem('adminAuthenticated') === 'true';
  });

  const handleLogin = (success) => {
    setIsAuthenticated(success);
    localStorage.setItem('adminAuthenticated', success.toString());
  };

  return (
    <div
      className="App"
      style={{
        background: `url('/assets/images/GAiN-2025-bg-scaled.jpg') center/cover fixed`,
        minHeight: '100vh'
      }}
    >
      <nav className="nav">
        <div className="nav-content">
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
              <img
                src="/assets/images/eud-gain.svg"
                alt="GAiN Logo"
                style={{ height: '40px', width: 'auto' }}
              />
            </Link>
            <h1 className="header-title">Polling Platform</h1>
          </div>
          {isAuthenticated && (
            <div className="nav-links">
              <Link to="/admin">Admin</Link>
              <button
                onClick={() => {
                  setIsAuthenticated(false);
                  localStorage.removeItem('adminAuthenticated');
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'var(--text-dark)',
                  cursor: 'pointer',
                  padding: '0.5rem 1rem',
                  borderRadius: '6px',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.background = 'var(--accent-color)'}
                onMouseOut={(e) => e.target.style.background = 'none'}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </nav>

      <div className="container">
        <Routes>
          <Route
            path="/"
            element={
              isAuthenticated ?
                <Admin /> :
                <AdminLogin onLogin={handleLogin} />
            }
          />
          <Route
            path="/admin"
            element={
              isAuthenticated ?
                <Admin /> :
                <AdminLogin onLogin={handleLogin} />
            }
          />
          <Route path="/vote/:sessionId" element={<Vote />} />
          <Route path="/results/:sessionId" element={<Results />} />
        </Routes>
      </div>
    </div>
  );
}


export default App;